import cx from 'classnames';
import Image from 'next/image';
import NextLink from 'next/link';

import {Button, Text} from '#component/base';
import {HoverEffect} from '#component/util';
import {sprinkles} from '#style/sprinkles';

import {ImageCTACardProps} from './ImageCTACard.types';

import * as css from './ImageCTACard.css';

export const ImageCTACard = ({
  className,
  eyebrow = '',
  lede = '',
  headline = '',
  href = '',
  imageUrl = '',
  imageClassName,
  objectPosition = '50% 50%',
  noFade,
  ...otherProps
}: ImageCTACardProps) => (
  <NextLink passHref href={href}>
    <a className={cx(css.root, className)} {...otherProps}>
      {imageUrl && (
        <Image
          alt=""
          aria-hidden
          className={cx(css.image({withFade: !noFade}), imageClassName)}
          layout="fill"
          objectFit="cover"
          objectPosition={objectPosition}
          src={imageUrl}
        />
      )}

      <span className={css.content({withFade: !noFade})}>
        <Text color="white" variant="heading4">
          {eyebrow}
        </Text>

        <span className={sprinkles({flex: 'flex', dir: ['col', 'col', 'row'], gap: [24, 24, 64]})}>
          <div className={sprinkles({flex: 'flex', dir: ['row', 'col'], gap: [16, 48]})}>
            <Text clamp={3} color="white" variant="heading2" className={css.headline}>
              {headline}
            </Text>

            <Button
              aria-label="Visit resource"
              as="span"
              className={sprinkles({display: ['flex', 'none', 'none']})}
              icon="ArrowRight"
            />
            {imageUrl && <span className={css.underline} />}
          </div>

          <div className={sprinkles({flex: 'flex', gap: [24, 64]})}>
            <Text clamp={5} color="white" variant="bodyLarge">
              {lede}
            </Text>

            <Button
              aria-hidden
              as="span"
              className={sprinkles({display: ['none', 'flex', 'flex']})}
              icon="ArrowRight"
            />
          </div>
        </span>
      </span>

      <HoverEffect />
    </a>
  </NextLink>
);
